import { createTheme } from "@material-ui/core";

export const CustomDefaultTheme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 320,
            md: 768,
            lg: 1366,
            xl: 1440,
        }
    },
    palette: {
        primary: {
            main: "#2c6ef2"
        },
        background: {
            paper: "#ffffff",
            default: "#f1f0ec",
        },
        secondary: {
            main: "#03a9f4",
            contrastText: "#ffffff"
        }
    }
});